import { AxiosError } from "axios";
import { api } from "../../api/api";
import GerarSegundaViaBoletoSienge from "../../model/sienge/boleto/GerarSegundaViaBoletoSienge";
import GerarBoletoResultSienge from "../../model/sienge/boleto/GerarBoletoResultSienge";

export default class BoletoService{

    gerarSegundaVia(dados: GerarSegundaViaBoletoSienge){
        return new Promise<GerarBoletoResultSienge>((resolve, reject): void => {
            let url = `/boleto/segundaVia`;
            api
                .post(url, dados)
                .then(response => resolve(response.data))
                .catch((err: AxiosError) => reject(err.response));
        });
    }
}